import React, { useMemo, useState } from 'react';
import { Tabs, Alert } from 'antd';
import { useAuth } from '../context/AuthContext';
import BehaviorTagsPage from './BehaviorTagsPage';
import SafetyProfilePage from './SafetyProfilePage';
import BehaviorDashboardPage from './BehaviorDashboardPage';
import BehaviorInterventionPage from './BehaviorInterventionPage';

const BehaviorControlPage = ({ defaultTab }) => {
  const { hasPermission } = useAuth();

  const canViewTags = hasPermission(['behavior_tags_view']) || hasPermission(['behavior_tags_manage']);
  const canViewProfile = hasPermission(['behavior_profile_view']);
  const canViewDashboard = hasPermission(['behavior_dashboard_view']);
  const canViewIntervention = hasPermission(['behavior_intervention_view']) || hasPermission(['behavior_intervention_manage']);

  const tabItems = useMemo(() => {
    const items = [];

    if (canViewTags) items.push({ key: 'tags', label: '行为标签体系', children: <BehaviorTagsPage /> });
    if (canViewProfile) items.push({ key: 'profile', label: '员工安全画像', children: <SafetyProfilePage /> });
    if (canViewDashboard) items.push({ key: 'dashboard', label: '行为仪表板', children: <BehaviorDashboardPage /> });
    if (canViewIntervention) items.push({ key: 'intervention', label: '行为干预管理', children: <BehaviorInterventionPage /> });

    return items;
  }, [canViewDashboard, canViewIntervention, canViewProfile, canViewTags]);

  const computedDefaultKey = useMemo(() => {
    if (defaultTab && tabItems.some(t => t.key === defaultTab)) return defaultTab;
    return tabItems[0]?.key;
  }, [defaultTab, tabItems]);

  const [activeKey, setActiveKey] = useState(computedDefaultKey);

  if (!tabItems.length) {
    return <Alert type="warning" showIcon message="无权限查看行为管控模块" />;
  }

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>行为管控</h2>
      <Tabs activeKey={activeKey} onChange={setActiveKey} items={tabItems} />
    </div>
  );
};

export default BehaviorControlPage;
